module.exports = __webpack_public_path__ + "static/media/tax-white.8caa08e8.png";